export type SlugTag = { slug: string; label: string };

export const DEFAULT_TAG_SLUGS: SlugTag[] = [
  { slug: 'trending', label: 'Trending' },
  { slug: 'featured', label: 'Featured' },
  { slug: 'politics', label: 'Politics' },
  { slug: 'sports', label: 'Sports' },
  { slug: 'crypto', label: 'Crypto' },
  { slug: 'finance', label: 'Finance' },
  { slug: 'geopolitics', label: 'Geopolitics' },
  { slug: 'earnings', label: 'Earnings' },
  { slug: 'tech', label: 'Tech' },
  { slug: 'culture', label: 'Culture' },
  { slug: 'world', label: 'World' },
  { slug: 'economy', label: 'Economy' },
  { slug: 'trump', label: 'Trump' },
  { slug: 'elections', label: 'Elections' },
];

export const DEFAULT_SLUG_URL_PATTERN = '/predictions/events/:slugId?';

const PARAM_PLACEHOLDER = /:[A-Za-z_]\w*\??/;
const OPTIONAL_SEGMENT = /\/:[A-Za-z_]\w*\?/;

export function formatSlugUrl(pattern: string, slug: string): string {
  if (slug === 'trending' && OPTIONAL_SEGMENT.test(pattern)) {
    return pattern.replace(OPTIONAL_SEGMENT, '');
  }
  return pattern.replace(PARAM_PLACEHOLDER, slug);
}

export function appendQueryParams(url: string, params: Record<string, string | undefined>): string {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value) query.set(key, value);
  }
  const qs = query.toString();
  return qs ? `${url}?${qs}` : url;
}
